import ConfirmationModal from 'components/modals/confirmation/ConfirmationModal';
import { useModal } from 'components/modals/useModal';
import { useDeleteEffortMutation } from 'store/api/efforts';
import { t } from 'utils/getTranslations';
import { useLeaveDeletedEntity } from 'utils/useNavigateWithReturnState';

/** Delete with its confirmation, then away from the deleted effort: the edit form's and the record header's. */
export const useConfirmDeleteEffort = (): ((effortId: string) => void) => {
    const { openModal, closeModal } = useModal();
    const [deleteEffort] = useDeleteEffortMutation();
    const leaveDeleted = useLeaveDeletedEntity('/efforts');

    return (effortId: string) =>
        openModal(
            <ConfirmationModal
                onCancel={closeModal}
                onConfirm={() => {
                    void deleteEffort({ id: effortId })
                        .unwrap()
                        .then(leaveDeleted)
                        .catch(console.error)
                        .finally(() => closeModal());
                }}
                content={<p className="text-body1">{t('efforts.delete-confirmation-text')}</p>}
            />
        );
};
